import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { FloatingCTA } from "./components/FloatingCTA";
import { PurchasePopup } from "./components/PurchasePopup";
import { Hero } from "./components/sections/Hero";
import { ProblemSection } from "./components/sections/ProblemSection";
import { BeforeAfterSection } from "./components/sections/BeforeAfterSection";
import { PainPointsSection } from "./components/sections/PainPointsSection";
import { VolumesSection } from "./components/sections/VolumesSection";
import { ToolsSection } from "./components/sections/ToolsSection";
import { BonusesSection } from "./components/sections/BonusesSection";
import { OfferSection } from "./components/sections/OfferSection";
import { GuaranteeSection } from "./components/sections/GuaranteeSection";
import { TestimonialsSection } from "./components/sections/TestimonialsSection";
import { AboutSection } from "./components/sections/AboutSection";
import { FaqSection } from "./components/sections/FaqSection";
import { FinalCtaSection } from "./components/sections/FinalCtaSection";
import { Footer } from "./components/sections/Footer";
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-cream font-sans text-ink" data-id="element-0" data-mp="3rc9e8848zfxr">
      <MetaPixel data-id="element-1" data-mp="3relu8fqg3g86" />
      <Hero data-id="element-2" data-mp="5ott78p769p" />
      <main data-id="element-3" data-mp="6htxpd5ixiv">
        <ProblemSection data-id="element-4" data-mp="4wupmfw6qeo" />
        <BeforeAfterSection data-id="element-5" data-mp="56nfhsbnbo2" />
        <PainPointsSection data-id="element-6" data-mp="2zl3a7gleoy37" />
        <VolumesSection data-id="element-7" data-mp="2zlv66six0xu0" />
        <ToolsSection data-id="element-8" data-mp="2zmemk4sx3e5x" />
        <BonusesSection data-id="element-9" data-mp="2zn6b4vo3kbmp" />
        <OfferSection data-id="element-10" data-mp="33mf2xuzktzfm" />
        <GuaranteeSection data-id="element-11" data-mp="33lwzoeehyky7" />
        <TestimonialsSection data-id="element-12" data-mp="33n6y54p9hv5d" />
        <AboutSection data-id="element-13" data-mp="33oi0r16z0wuw" />
        <FaqSection data-id="element-14" data-mp="38l8idsyfc0if" />
        <FinalCtaSection data-id="element-15" data-mp="38kqb81a841vq" />
      </main>
      <Footer data-id="element-16" data-mp="38nuqbtp88i16" />
      <FloatingCTA anchorId="hero-cta" data-id="element-17" data-mp="3dkuuu06fhcq6" />
      <PurchasePopup data-id="element-18" data-mp="3dlw5w4ng1z7w" />
    </div>;
}